import styles from "./statusTab.scss";
const CustomStatusFlag = ({serviceAccountStatusCode}) => {
    let status = serviceAccountStatusCode === 'A' ? "ACTIVE" : serviceAccountStatusCode === 'I' ? "INACTIVE" : "PENDING";
    const displayStatus = <span className={status === "ACTIVE" ? styles.statusContentBtnAct : status === "INACTIVE" ? styles.statusContentBtnInAct : styles.statusContentBtnPen}>{status}</span>;

    return (
        <span className={styles.statusContent}>
            {displayStatus}
        </span>
    );
};
export default CustomStatusFlag;